
import * as api from "../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";

// import * as api from "../constant/API";
import { Link } from "react-router-dom";
import Utils from "../constant/Utils";
import Swal from "sweetalert2";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";

const ProgramLevel = () => {

    const [searchInput, setSearchInput] = useState("");
    const [programList, setProgramList] = useState([]);
    const [programName, setProgramName] = useState('');
    const [programOrder, setProgramOrder] = useState('');
    const [programId, setProgramId] = useState('');
    const [programStatus, setProgramStatus] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const formRef = useRef(null);

    const roleId = localStorage.getItem('RoleId');

    useEffect(() => {
        progList(null);
    }, [])

    function progList(par: string | null) {
        let getProgList = api.ProgramsList;
        if (par) {
            getProgList += "/" + par;
        }
        fetch(getProgList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((progResponse) => progResponse.json())
            .then((progResult) => {
                if (progResult.code == 401) {
                    Utils.logoutUser();
                }
                if (par) {
                    // const res = progResult.data[0];
                    const res = progResult.data;
                    setProgramId(res.programId);
                    setProgramName(res.programName);
                    setProgramOrder(res.programOrder);
                    setProgramStatus(res.programStatus);
                }
                else {
                    setProgramList(progResult.data)
                }
            })
            .catch((error) => {
                console.log('Failed to fetch the program list', error)
            })
    }

    function editProg(row) {
        const id = row.programId;
        progList(id);
        setIsEdit(true);
        setOpenModal(true);
    }

    function setInitial() {
        setProgramId('');
        setProgramName('');
        setProgramOrder('');
        setProgramStatus('');
    }

    function addProgram(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateProg();
            } else {
                const formData = new FormData();
                formData.append("programName", programName);
                formData.append("programOrder", programOrder);

                const createProg = api.CreateProgram;
                fetch(createProg, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((createResponse) => createResponse.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("Failed to create program", error)
                    })
            }
            setOpenModal(false)
        }
    }

    function updateProg() {
        const formData = new FormData();
        formData.append("programId", programId);
        formData.append("programName", programName);
        formData.append("programOrder", programOrder);
        formData.append("programStatus", programStatus);

        const updateProgram = api.UpdateProgram;
        fetch(updateProgram, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((updateResponse) => updateResponse.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
            .catch((error) => {
                console.log("Failed to update the program", error);
            })
    }

    const filteredData = programList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value.toString().toLowerCase()
        );
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const nameRender = (rowData) => {
        return <span>{rowData.programName}</span>;
    };

    const orderRender = (rowData) => {
        return <span>{rowData.programOrder}</span>
    }

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editProg(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        {roleId == '1' ? (
                                            <>
                                                <div className="row col-md-12">
                                                    <div className="col-md-4">
                                                        <Link
                                                            to="#"
                                                            className="btn btn-secondary"
                                                            onClick={() => { setOpenModal(true); setIsEdit(false); setInitial(); }}>
                                                            <i className="feather-plus" />&nbsp;
                                                            Add Program
                                                        </Link>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-md-6">
                                        </div>
                                        <div className="col-md-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50]}
                                                currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    body={slNoRender}
                                                    header="Sl &nbsp; No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="programName"
                                                    header="Name"
                                                    body={nameRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="programId"
                                                    header="Order"
                                                    body={orderRender}
                                                ></Column>

                                                {(roleId == '1') ? (
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                ) : null}
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add/ Edit Program */}
            <Modal
                show={openModal}
                centered
                size="md"
                onHide={() => setOpenModal(false)}>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 text-uppercase"><i className="fas fa-plus" />{isEdit ? 'Edit' : 'Add'} Program</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="mb-10">
                            <label className="form-label">Program</label>
                            <input
                                id="progName"
                                className="form-control"
                                style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                value={programName}
                                placeholder="Program Name"
                                required
                                onChange={(e) => {
                                    setProgramName(e.target.value)
                                }}
                            />
                        </div>
                        <div className="mb-10">
                            <label className="form-label">Program Order</label>
                            <input
                                id="progOrdr"
                                className="form-control"
                                style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                value={programOrder}
                                placeholder="Program Order"
                                required
                                onChange={(e) => {
                                    setProgramOrder(e.target.value)
                                }}
                            />
                        </div>
                        {isEdit ?
                            <>
                                <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                                    <label className="form-label">Status</label>
                                </div>
                                <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                                    <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                        <input
                                            className="form-check-input text-end"
                                            type="checkbox"
                                            checked={programStatus === '1'}
                                            id="instistatus"
                                            onChange={(e) => {
                                                setProgramStatus(e.target.checked ? '1' : '0')
                                            }}
                                        />
                                    </div>
                                </div>
                            </> : null
                        }
                    </form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-primary text-uppercase"
                        variant="success"
                        onClick={addProgram}
                        data-bs-dismiss="modal" aria-label="Close"
                    >
                        <b><i className="fas fa-save" />{isEdit ? "Update" : "Save"}</b>
                    </Button>
                </ModalFooter>
            </Modal>
            {/* /Add/ Edit Program */}
        </>
    );
};

export default ProgramLevel;